import apiV2 from "./api";

const state = {
  kitV2Data: {},
  kitV2Details: {},
  kitVersionProfile: null,
  dashboardView: localStorage.getItem("dashboardView") || "v1"
};

const mutations = {
  setKitV2Data(state, data) {
    state.kitV2Data = data;
  },
  setKitV2Details(state, data) {
    state.kitV2Details = data;
  },
  setKitVersionProfile(state, version) {
    state.kitVersionProfile = version;
  },
  setDashboardView(state, view) {
    state.dashboardView = view;
    localStorage.setItem("dashboardView", view);
  }
};

const actions = {
  activateKitV2({ commit }, data) {
    return apiV2.post("/v2/kits/create", data).then(res => {
      commit("setKitV2Data", res.data.data.testkit);
      return res;
    }).catch(error => {
      return Promise.reject(error);
    });
  },
  associateKitV2({ commit }, data) {
    return apiV2.post("/v2/kits/associate", data).then(res => {
      commit("setKitV2Data", res.data.data.testkit);
      return res;
    }).catch(error => {
      return Promise.reject(error);
    });
  },
  confirmationsV2({ commit }, data) {
    return apiV2.post("/v2/kits/confirmations", data).then(res => {
      return res;
    }).catch(error => {
      return Promise.reject(error);
    });
  },
  sendTempSubV2({ commit }, data) {
    return apiV2.put("/v2/kits/tempsubmission", data).then(res => {
      return res;
    }).catch(() => {
      // Silently ignore temp submission errors — not critical for activation
    });
  },
  testuserV2({ commit }, kitId) {
    return apiV2.get("/v2/kits/testuser?kit_id=" + kitId).then(res => {
      return res.data.data;
    });
  },
  saveKitV2Details({ commit }, data) {
    commit("setKitV2Details", data);
    return Promise.resolve();
  },
  switchDashboardView({ commit }, view) {
    commit("setDashboardView", view);
  },
  // Kit detail with all relationships
  fetchKitV2Detail({ commit }, kitId) {
    return apiV2.get("/v2/kits/detail?kit_id=" + kitId).then(res => {
      return res.data.data.kit;
    });
  },
  // Timeline
  fetchKitV2Timeline({ commit }, kitId) {
    return apiV2.get("/v2/kits/timeline?kit_id=" + kitId).then(res => {
      return res.data.data;
    });
  },
  // Samples CRUD
  fetchSamplesV2({ commit }, kitId) {
    return apiV2.get("/v2/kits/samples?kit_id=" + kitId).then(res => {
      return res.data.data.samples;
    });
  },
  addSampleV2({ commit }, data) {
    return apiV2.post("/v2/kits/samples", data).then(res => {
      return res.data.data.sample;
    });
  },
  updateSampleV2({ commit }, { id, data }) {
    return apiV2.put("/v2/kits/samples/" + id, data).then(res => {
      return res.data.data.sample;
    });
  },
  deleteSampleV2({ commit }, id) {
    return apiV2.delete("/v2/kits/samples/" + id).then(res => {
      return res.data;
    });
  },
  shareReportV2({ commit }, data) {
    return apiV2.post("/v2/kits/share-report", data).then(res => {
      return res.data;
    });
  }
};

const getters = {
  kitV2Data() {
    return state.kitV2Data;
  },
  kitV2Details() {
    return state.kitV2Details;
  },
  kitVersionProfile() {
    return state.kitVersionProfile;
  },
  dashboardView() {
    return state.dashboardView;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
